
@switch (activeSignButton$ | async) {
@case ('SIGN_IN') {
<sign-in-ui
  [signInForm]="getFormGroup('signInForm')"
  [isSubmitTriggered]="isSignInSubmitTriggered"
  (forgotPasswordEmitter)="forgotPassword()"
  (signUpViewEmitter)="signUpView()"
  (signInSubmitEmitter)="signInSubmit()"></sign-in-ui>
}
@case ('SIGN_UP') {
<sign-up-ui
  [signUpForm]="getFormGroup('signUpForm')"
  [isSubmitTriggered]="isSignUpSubmitTriggered"
  [countries]="countries$ | async"
  [states]="states$ | async"
  (signInViewEmitter)="signInView()"
  (signUpSubmitEmitter)="signUpSubmit()"
  (onTermsEmitter)="onTermsEmitter()"
  (onPrivacyEmitter)="onPrivacyEmitter()"
  (selectedCountry)="selectedCountry($event)"
  (selectedState)="selectedState($event)"></sign-up-ui>
}
@case ('FORGOT_PASSWORD') {
<forgot-password-ui
  [isOTPRequested]="isOTPRequested$ | async"
  [isSubmitTriggered]="isFPSubmitTriggered"
  [fpForm]="getFormGroup('fpForm')"
  (requestOTPEmitter)="requestOTP($event)"
  (cancelEmitter)="cancelFP()"
  (resetPasswordSubmitEmitter)="resetPasswordSubmit()"></forgot-password-ui>
}
@case ('RESET_UPDATE') {
<reset-update (signInViewEmitter)="signInView()"></reset-update>
}
<!-- @case ('MOBILE_MENU') {
<mobile-menu
  (signInViewEmitter)="mobileSignInView()"
  (signUpViewEmitter)="mobileSignUpView()"
  (closeDialogMenuEmitter)="closeDialogMenu()"></mobile-menu>
} -->
}
